export class RepairType {
    id: number;
    code: string;
    name: string;
    description: string;
    durationMonths: number;
    parentRepairTypeId: number;
}